module.exports = __webpack_public_path__ + "static/media/u1F610.b385d050.webp";